var map = {
	"./auth/locale/en.json": "292e",
	"./azmoon/locale/en.json": "cf4d",
	"./cooperation/locale/en.json": "4fb9",
	"./home/locale/en.json": "4869",
	"./interview/locale/en.json": "879f",
	"./jobsProfile/locale/en.json": "6bd9",
	"./kanoon/locale/en.json": "21d8",
	"./profile/locale/en.json": "5ab5",
	"./report/locale/en.json": "cd0b",
	"./research/locale/en.json": "dd40",
	"./survey/locale/en.json": "774e",
	"./task/locale/en.json": "3243",
	"./ticket/locale/en.json": "2f0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63fd";